import { DropdownOptions } from '@shared/ui';
import { sectionHeading } from '../profileStyles';
import { dropdownErrorClassName } from '@shared/ui/formStyles';

/**
 * Main contact selector.
 *
 * The `useMainContact` hook is called by the parent rather than here, because the parent builds the
 * zod schema and has to know whether there are any contacts to choose from — requiring a selection
 * from an empty list would block every save on the form, including fields unrelated to the contact.
 */
export function MainContactSection({
  canEditBillingAndContact,
  register,
  errors,
  contactOptions,
  loadingContacts,
  selectedContactId,
  handleContactChange,
  canLoadContacts,
  dataTestId,
}) {
  const baseTestId = dataTestId || 'profile-contact-section';

  return (
    <div className="space-y-4" data-testid={baseTestId}>
      <h3 className={sectionHeading} data-testid={`${baseTestId}-header`}>Main Contact</h3>

      {canEditBillingAndContact ? (
        <DropdownOptions
          id="mainContactId"
          label="Main Contact"
          value={selectedContactId || ""}
          onValueChange={handleContactChange}
          options={contactOptions}
          loading={loadingContacts}
          disabled={!canLoadContacts}
          placeholder={canLoadContacts ? "Select main contact" : "Client or site information not available"}
          required
          error={errors.mainContactId?.message}
          errorClassName={dropdownErrorClassName}
          dataTestId={`${baseTestId}-dropdown`}
        />
      ) : null}

      {/* Hidden fields to store the selected contact data */}
      <input type="hidden" {...register('mainContactUsername')} data-testid={`${baseTestId}-hidden-username`} />
    </div>
  );
}
